import React from 'react';
import { MessageSquare } from 'lucide-react';
import { ENABLE_FEEDBACK } from '../../types/feedback';

interface FeedbackFABProps {
  onClick: () => void;
}

export default function FeedbackFAB({ onClick }: FeedbackFABProps) {
  if (!ENABLE_FEEDBACK) return null;

  return (
    <button
      onClick={onClick}
      className="fixed bottom-6 right-6 z-40 w-14 h-14 bg-blue-600 hover:bg-blue-700 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center group"
      title="Send Feedback"
      aria-label="Send Feedback"
    >
      <MessageSquare className="w-6 h-6 group-hover:scale-110 transition-transform" />
    </button>
  );
} 